var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4064 24.2171C18.4064 19.8821 22.8014 17.2003 27.3914 19.1353C29.6264 20.0803 30.9764 22.4053 30.9614 24.8353C30.9614 25.0453 31.1264 25.2103 31.3214 25.2103H44.9114C45.3314 25.2103 45.6914 24.8653 45.6764 24.4303C45.2714 13.0903 36.0314 4.03027 24.6914 4.03027C13.3514 4.03027 3.88641 13.3153 3.69141 24.8353C3.69141 25.0303 3.85641 25.1953 4.05141 25.1953H18.0614C18.2564 25.1953 18.4214 25.0303 18.4214 24.8353L18.4064 24.2171Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95225 12.9311L19.0242 20.9012C19.1709 21.0055 19.2149 21.2141 19.1269 21.363C18.9509 21.6908 18.7603 22.0781 18.6136 22.5399C18.423 23.1209 18.3496 23.6572 18.3203 24.1041C18.291 24.4915 17.983 24.8192 17.5871 24.8192H4.66732C4.24204 24.8192 3.91941 24.4617 3.93407 24.0446C3.97807 22.7634 4.13938 21.2141 4.57933 19.5158C5.31257 16.6406 6.51509 14.4507 7.48297 12.9907C7.58563 12.8269 7.8056 12.7971 7.96692 12.9162L7.95225 12.9311Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5621 13.2097L30.2371 21.2497C30.0871 21.3547 30.0421 21.5497 30.1321 21.7147C30.4021 22.2097 30.9271 23.3197 30.9871 24.5197C31.0021 24.9097 31.3321 25.2097 31.7221 25.2097H45.3271C45.5221 25.2097 45.6871 25.0597 45.6871 24.8497C45.6721 23.4697 45.5071 21.7597 45.0271 19.8547C44.2771 16.9597 43.0471 14.7547 42.0571 13.2847C41.9521 13.1197 41.7271 13.0897 41.5621 13.2097Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3972 5.53057L27.0322 18.6706C26.9722 18.8506 27.0472 19.0306 27.2122 19.1056C27.7522 19.3606 28.9672 20.0356 29.7622 21.1306C29.8822 21.2956 30.1072 21.3406 30.2722 21.2206L41.5672 13.2106C41.7322 13.0906 41.7772 12.8806 41.6572 12.7156C40.9972 11.8006 40.1872 10.8256 39.1522 9.85057C36.5572 7.37557 33.8272 6.04057 31.8472 5.30557C31.6522 5.23057 31.4572 5.33557 31.3972 5.53057Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5246 4.94119C19.9346 4.51519 25.5446 3.09029 31.1696 5.04401C31.3496 5.10277 31.4546 5.30843 31.3946 5.48471L27.0296 18.3382C26.9696 18.5144 26.7746 18.6173 26.5796 18.5585C25.9796 18.3822 24.6296 18.0738 23.0996 18.4704C22.9196 18.5144 22.7096 18.4263 22.6496 18.25L18.2996 5.39657C18.2396 5.2056 18.3296 5.01464 18.5246 4.95588V4.94119Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4786 5.16992L26.9336 19.1049L31.4786 5.16992Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9336 21.4454L41.8736 12.9404L29.9336 21.4454Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7142 18.7907L18.1992 5.0957L22.7142 18.7907Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51953 12.9258L19.4145 21.4308L7.51953 12.9258Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6327 19.1234C36.6306 19.1213 36.6277 19.1203 36.6248 19.1206L24.1644 20.5151C23.8194 20.5601 23.5794 20.8751 23.6544 21.2201L23.8194 22.0601C23.8794 22.4051 24.2244 22.6151 24.5694 22.5251L36.6285 19.1396C36.6356 19.1376 36.6379 19.1287 36.6327 19.1234Z",
    fill: "#000105",
    stroke: "#000105",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.1fd490f9373a7c503592543b68ba1a62.svg";
export { ForwardRef as ReactComponent };